/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".radio-container[_ngcontent-%COMP%]{padding-top:5px;white-space:nowrap;margin-bottom:3px}.org-type-radio-group[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-bottom:3px}.org-type-radio-group__option[_ngcontent-%COMP%]{display:block;padding:4px 0}.no-wrap-container[_ngcontent-%COMP%]{white-space:nowrap}"];
export { styles as styles };
